import { Box } from "@mui/material";
import { SelectedCheckboxIcon } from "components/Icons/Icons";

export const CustomUncheckedIcon = () => (
  <Box
    sx={{
      width: 22,
      height: 22,
      borderRadius: "4px",
      border: "1px solid",
      borderColor: "divider",
    }}
  />
);

export const CustomCheckedIcon = (props) => (
  <Box
    sx={{
      width: 22,
      height: 22,
      borderRadius: "4px",
      backgroundColor: props.disabled ? "divider" : "primary.main",
      position: "relative",
    }}
  >
    <SelectedCheckboxIcon
      sx={{
        color: "primary.contrastText",
        width: 16,
        height: 16,
        position: "absolute",
        top: "3px",
        left: "3px",
      }}
    />
  </Box>
);
